/* ==========================================================================
   SPICY HOME — BACKGROUND FILM
   Hydration and playback control for every <video data-sh-video>.

   Films on this site are atmosphere, never content the visitor must watch.
   That principle drives the whole file:

     · Nothing downloads until it is nearly on screen. The markup ships with
       no <source> at all, so the browser cannot pre-fetch a 1080p file for a
       section four screens down.
     · Phones get the smaller rendition. Chosen before the first byte moves.
     · Offscreen films pause. No CPU or battery spent on something nobody is
       looking at.
     · prefers-reduced-motion and Save-Data get the poster frame only. Not a
       degraded experience — a photograph, which is what the brand is built on.
     · If autoplay is refused, the poster stands in silently. No play button
       appears, because there is nothing the visitor needs to do.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__spicyVideo) return;
  window.__spicyVideo = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SMALL = window.matchMedia('(max-width: 768px)');

  // Respect a metered or slow connection where the browser reports one.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var THRIFTY = !!conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''));

  var ALLOWED = !REDUCED && !THRIFTY;

  var observer = null;

  function sourceFor(video) {
    var small = video.getAttribute('data-src-mobile');
    var large = video.getAttribute('data-src');
    return (SMALL.matches && small) ? small : large;
  }

  function hydrate(video) {
    if (video.getAttribute('data-sh-hydrated')) return;

    var url = sourceFor(video);
    if (!url) return;

    video.setAttribute('data-sh-hydrated', '1');

    var source = document.createElement('source');
    source.type = 'video/mp4';
    source.src = url;
    video.appendChild(source);
    video.load();

    // Fade the film in over its own poster so the swap is never a hard cut.
    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    }, { once: true });

    play(video);
  }

  function play(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      // Autoplay refused (common on iOS Low Power Mode). The poster is
      // already visible and correct, so there is nothing to recover from.
      attempt.catch(function () {});
    }
  }

  function observe(video) {
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (!video.getAttribute('data-sh-hydrated')) {
              hydrate(video);
            } else if (video.paused) {
              play(video);
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0 });
    }
    observer.observe(video);
  }

  function init(scope) {
    var root = scope || document;
    var videos = root.querySelectorAll('video[data-sh-video]:not([data-sh-seen])');

    Array.prototype.forEach.call(videos, function (video) {
      video.setAttribute('data-sh-seen', '1');

      if (!ALLOWED) {
        // Poster only. Remove autoplay so no browser decides otherwise.
        video.removeAttribute('autoplay');
        video.classList.add('is-poster-only');
        return;
      }

      // The hero cannot wait for an observer callback — it is the first thing
      // on screen and the film is the point of it.
      if (video.hasAttribute('data-sh-video-eager')) {
        hydrate(video);
        observe(video);
        return;
      }

      if ('IntersectionObserver' in window) {
        observe(video);
      } else {
        hydrate(video);
      }
    });
  }

  // Pause everything while the tab is in the background.
  document.addEventListener('visibilitychange', function () {
    var videos = document.querySelectorAll('video[data-sh-video][data-sh-hydrated]');
    Array.prototype.forEach.call(videos, function (video) {
      if (document.hidden) {
        video.pause();
      } else if (video.getBoundingClientRect().top < window.innerHeight) {
        play(video);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  // Theme editor: a re-rendered section brings new, unhydrated elements.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.SpicyVideo = { init: init };
})();
